import React from 'react';
import { connect } from 'react-redux';
import { Items } from 'Utils/SvgIcons';
import Imgix from 'react-imgix';
import PageMetaData from 'Utils/PageMetaData';
import { getSettingByUrl } from 'HelperFunctions/StorefrontPage';

class Showcase extends React.Component {
  render() {
    const { storefrontSetting, themeSetting } = this.props;
    const { storefrontShowcaseCategories } = storefrontSetting;
    // The themes pick a column count from this class, so it must always be
    // `countN`. It used to be built with a ternary whose condition was
    // `'count' + storefrontShowcaseCategories` — always a truthy string, so the
    // class came out as the bare number (`class="3"`) and every theme rule
    // written against `.countN` was dead.
    const showcaseCategories = storefrontShowcaseCategories || [];
    return (
      <div className='showcase'>
        <PageMetaData setting={storefrontSetting} />
        <section className={`count${showcaseCategories.length}`}>
          {showcaseCategories.map((showcaseCategory) => (
            <a href={showcaseCategory.categoryLink} key={showcaseCategory.id}>
              <figure>
                {showcaseCategory.picture ? (
                  <Imgix
                    src={showcaseCategory.picture.imgixUrl}
                    alt='category_picture'
                    sizes='50vw'
                  />
                ) : (
                  <Items />
                )}
              </figure>
              <div
                className='btn secondary'
                style={{
                  color:
                    showcaseCategory.categoryTitleFontTheme === 'dark'
                      ? 'var(--dark-font-color)'
                      : 'var(--light-font-color)',
                }}
              >
                {showcaseCategory.categoryTitle}
              </div>
            </a>
          ))}
        </section>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { location, parsedStorefrontSettings } = state.locations;
  const themeSetting = parsedStorefrontSettings.mainSetting;
  const storefrontSetting = getSettingByUrl(
    location.storefrontPages,
    ownProps.location.pathname
  );
  return { storefrontSetting, themeSetting };
};

export default connect(mapStateToProps)(Showcase);
